/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Event from "../lib/Event";
//import FirebaseUtils from "lib/FirebaseUtils";
import PubSub from "../lib/PubSub";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import _ from "underscore";
import {
  IonCard,
  IonCardContent,
  IonGrid,
  IonCol,
  IonRow,
  IonIcon,
} from "@ionic/react";

import chicken from "../assets/img/icons/protein_chicken_noborder.svg";
import beef from "../assets/img/icons/protein_beef_noborder.svg";
import pork from "../assets/img/icons/protein_pork_noborder.svg";
import turkey from "../assets/img/icons/protein_turkey_noborder.svg";
import plant from "../assets/img/icons/protein_plant_noborder.svg";
import egg from "../assets/img/icons/protein_egg_noborder.svg";
import other from "../assets/img/icons/protein_other_noborder.svg";
import fish from "../assets/img/icons/protein_fish_noborder.svg";

import {
  heart,
  information,
  star,
  starHalf,
  starOutline,
  trash,
} from "ionicons/icons";
import StringUtils from "../lib/StringUtils";
import SegmentUtils from "../lib/SegmentUtils";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";

class MealOptionCard extends React.Component<{
  mobile?: boolean;
  meal?: any;
  selected?: any;
  disableAdd?: boolean;
  incrementMeal?: any;
  compact?: boolean;
  checkoutMode?: boolean;
  modalID?: string;
  position?: number;
  favorite?: boolean;
  allowFavorite?: boolean;
  onFavoriteChange?: any;
  reviews?: any;
  showReviews?: boolean;
  outOfStock?: boolean;
  limitedAvailability?: boolean;
}> {
  state: any = {};

  openMealInfo(meal: any) {
    if (this.props.checkoutMode) {
      return;
    }

    // Haptic feedback
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Medium });
    }

    let props: any = {
      brand: "Project LeanNation",
      category: meal?.planType?.name + " Meals",
      image_url: meal?.imageURL,
      name: meal?.name,
      product_id: meal?._id,
      url: meal?.deeplinkURL,
    };

    if (this.props.position) {
      props.position = this.props.position;
    }

    SegmentUtils.track("Product Clicked", props);

    meal.quantity = this.props.selected ? this.props.selected : 0;

    PubSub.publish(Event.MEAL.OPEN_INFO, { meal, id: this.props.modalID });
  }

  renderTopCategory(meal: any) {
    let top: any = "";
    let priority = 0;

    if (!meal?.categories?.length) {
      return <></>;
    }

    for (let i = 0; i < meal.categories.length; i++) {
      let cat = meal.categories[i];

      if (cat.name == "Best Sellers" && priority <= 110) {
        top = (
          <div
            className={`inline-block px-sm-2 text-primary font-weight-700 text-uppercase ${
              !this.props.mobile && "px-1 py-[0.1rem]"
            }`}
            style={{
              fontSize: this.props.mobile ? 10 : "12px",
              borderRadius: "3px",
              background: "var(--primary-ultralight)",
              border: "1px solid var(--primary)",
              paddingLeft: this.props.mobile ? "0.2rem" : "",
              paddingRight: this.props.mobile ? "0.2rem" : "",
              paddingTop: this.props.mobile ? "0.15rem" : "",
              paddingBottom: this.props.mobile ? "0.15rem" : "",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 110;
      }

      if (cat.name == "New" && priority <= 105) {
        top = (
          <div
            className="inline-block px-sm-2 px-1 py-[0.1rem] text-primary text-uppercase border border-primary font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              background: "var(--primary-ultralight)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 110;
      }

      if (cat.name == "Lean Cheats" && priority <= 100) {
        top = (
          <div
            color="danger"
            className="inline-block px-sm-2 px-1 py-[0.1rem] bg-white text-dark text-uppercase font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 100;
      }

      if (cat.name == "Plant Based" && priority <= 90) {
        top = (
          <div
            color="success"
            className="inline-block px-sm-2 px-1 py-[0.1rem] bg-white text-dark text-uppercase font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 90;
      }

      if (cat.name == "Grain Free" && priority <= 80) {
        top = (
          <div
            color="warning"
            className="inline-block px-sm-2 px-1 py-[0.1rem] bg-white text-uppercase text-dark font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 80;
      }

      if (cat.name == "Dairy Free" && priority <= 70) {
        top = (
          <div
            color="info"
            className="inline-block px-sm-2 px-1 py-[0.1rem] bg-white text-uppercase text-dark font-weight-bold"
            style={{
              fontSize: this.props.mobile ? 11 : "12px",
              borderRadius: "3px",
              border: "1px solid var(--light)",
            }}
          >
            {cat.name}
          </div>
        );
        priority = 70;
      }
    }

    if (!top) {
      top = (
        <div
          color="info"
          className="inline-block px-sm-2 px-1 py-[0.1rem] bg-white text-uppercase text-dark font-weight-bold"
          style={{
            fontSize: this.props.mobile ? 11 : "12px",
            borderRadius: "3px",
            border: "1px solid var(--light)",
          }}
        >
          Balanced
        </div>
      );
    }

    return top;
  }

  getSegmentProps() {
    let props: any = {
      brand: "Project LeanNation",
      category: this.props.meal?.planType?.name + " Meals",
      category_id: this.props.meal?.planType?._id,
      image_url: this.props.meal?.imageURL,
      name: this.props.meal?.name,
      product_id: this.props.meal?._id,
      url: this.props.meal?.deeplinkURL,
      quantity: 1,
    };

    if (this.props.position) {
      props.position = this.props.position;
    }

    return props;
  }

  isInSelected(meal: any) {
    let i = _.findWhere(this.state.selectedMeals, { _id: meal._id });

    if (i) {
      return true;
    }

    return false;
  }

  getProteinIcon(meal: any) {
    if (!meal?.primaryProteinCategory) {
      return "";
    }

    const cat = meal?.primaryProteinCategory?.toLowerCase();

    if (cat == "chicken") {
      return chicken;
    }

    if (cat == "beef") {
      return beef;
    }

    if (cat == "pork") {
      return pork;
    }

    if (cat == "turkey") {
      return turkey;
    }

    if (cat == "fish") {
      return fish;
    }

    if (cat == "plant based") {
      return plant;
    }

    if (cat == "lean cheat") {
      return other;
    }

    if (cat == "egg") {
      return egg;
    }
  }

  renderRating(score: number) {
    score = Math.ceil(score * 10) / 10;

    if (score >= 5) {
      return "5";
    }

    return score.toFixed(1);
  }

  stripHTML(html: any) {
    return html.replace(/(<([^>]+)>)/gi, "");
  }

  convertToPlain(html: any) {
    return StringUtils.htmlToText(html);
  }

  renderReviews(score: number) {
    const stars: any = [];

    score = parseFloat(score.toFixed(1));

    // Score is zero to five
    // Make it support rendering up to 5 stars in the array
    // Each full point is a solid star
    // Each partial point is a half star
    // If the score is a decimal, round down to the nearest half
    // Add remaining outline stars to reach 5 total

    if (score == 0) {
      return [
        <IonIcon key={0} icon={starOutline} color="medium" />,
        <IonIcon key={1} icon={starOutline} color="medium" />,
        <IonIcon key={2} icon={starOutline} color="medium" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score < 1) {
      return [
        <IonIcon key={0} icon={starHalf} color="primary" />,
        <IonIcon key={1} icon={starOutline} color="medium" />,
        <IonIcon key={2} icon={starOutline} color="medium" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score == 1) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={starOutline} color="medium" />,
        <IonIcon key={2} icon={starOutline} color="medium" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 1.5) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={starHalf} color="primary" />,
        <IonIcon key={2} icon={starOutline} color="medium" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 2) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={star} color="primary" />,
        <IonIcon key={2} icon={starOutline} color="medium" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 2.5) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={star} color="primary" />,
        <IonIcon key={2} icon={starHalf} color="primary" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 3) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={star} color="primary" />,
        <IonIcon key={2} icon={star} color="primary" />,
        <IonIcon key={3} icon={starOutline} color="medium" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 3.5) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={star} color="primary" />,
        <IonIcon key={2} icon={star} color="primary" />,
        <IonIcon key={3} icon={starHalf} color="primary" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 4) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={star} color="primary" />,
        <IonIcon key={2} icon={star} color="primary" />,
        <IonIcon key={3} icon={star} color="primary" />,
        <IonIcon key={4} icon={starOutline} color="medium" />,
      ];
    }

    if (score <= 4.5) {
      return [
        <IonIcon key={0} icon={star} color="primary" />,
        <IonIcon key={1} icon={star} color="primary" />,
        <IonIcon key={2} icon={star} color="primary" />,
        <IonIcon key={3} icon={star} color="primary" />,
        <IonIcon key={4} icon={starHalf} color="primary" />,
      ];
    }

    return [
      <IonIcon key={0} icon={star} color="primary" />,
      <IonIcon key={1} icon={star} color="primary" />,
      <IonIcon key={2} icon={star} color="primary" />,
      <IonIcon key={3} icon={star} color="primary" />,
      <IonIcon key={4} icon={star} color="primary" />,
    ];
  }

  render() {
    return (
      <>
        {this.props.mobile ? (
          <>
            <IonCard
              mode="ios"
              className="m-0 meal-info-card "
              style={{
                borderRadius: 0,
                boxShadow: "none",
              }}
            >
              <IonCardContent
                className="p-0 bg-white border-[1px] md:border-[0px] border-gray-100"
                style={{
                  borderRadius: 12,
                }}
              >
                <div className="d-flex">
                  <div
                    className={`p-2 ${
                      !this.props.checkoutMode && "cursor-pointer"
                    }`}
                    style={{
                      width: `calc(100% - ${
                        this.props.checkoutMode
                          ? "80px"
                          : Capacitor.getPlatform() == "ios"
                          ? "130px"
                          : "115px"
                      })`,
                    }}
                  >
                    <div onClick={() => this.openMealInfo(this.props.meal)}>
                      <div className={`mb-1 ${this.props.compact && "d-none"}`}>
                        <div className="flex items-center">
                          <div className="pl-0 py-0 grow">
                            <div
                              className={`${
                                this.props.meal?.limitedAvailability
                                  ? "sm:flex gap-x-2 lg:block gap-y-1"
                                  : "inline-block"
                              }`}
                            >
                              {this.props.meal?.limitedAvailability &&
                              !this.props.meal?.outOfStock ? (
                                <>
                                  <div
                                    className={`inline-block mr-[0.45rem] sm:mr-0 px-sm-2 bg-gray-50 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase ${
                                      !this.props.mobile && "px-1 py-[0.1rem]"
                                    }`}
                                    style={{
                                      fontSize: this.props.mobile ? 11 : "12px",
                                      borderRadius: "3px",

                                      paddingLeft: this.props.mobile
                                        ? "0.2rem"
                                        : "",
                                      paddingRight: this.props.mobile
                                        ? "0.2rem"
                                        : "",
                                      paddingTop: this.props.mobile
                                        ? "0.15rem"
                                        : "",
                                      paddingBottom: this.props.mobile
                                        ? "0.15rem"
                                        : "",
                                    }}
                                  >
                                    Limited Stock
                                  </div>
                                </>
                              ) : null}
                              {this.props.meal?.outOfStock ? (
                                <>
                                  <div
                                    className={`inline-block mr-[0.45rem] sm:mr-0 px-sm-2 bg-gray-50 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase ${
                                      !this.props.mobile && "px-1 py-[0.1rem]"
                                    }`}
                                    style={{
                                      fontSize: this.props.mobile ? 11 : "12px",
                                      borderRadius: "3px",

                                      paddingLeft: this.props.mobile
                                        ? "0.2rem"
                                        : "",
                                      paddingRight: this.props.mobile
                                        ? "0.2rem"
                                        : "",
                                      paddingTop: this.props.mobile
                                        ? "0.15rem"
                                        : "",
                                      paddingBottom: this.props.mobile
                                        ? "0.15rem"
                                        : "",
                                    }}
                                  >
                                    Out Of Stock
                                  </div>
                                </>
                              ) : null}
                              <div className="flex gap-x-2 d-inline-block">
                                {this.renderTopCategory(this.props.meal)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <h3
                          className={`${
                            !this.props.compact && "pt-[0.3rem]"
                          } mb-0 text-truncate text-dark font-weight-500 font-[SourceSerif] ${
                            this.props.checkoutMode &&
                            "d-flex ion-align-items-center"
                          }`}
                          style={{ fontSize: 18 }}
                        >
                          <div
                            style={{
                              flexGrow: this.props.checkoutMode ? "1" : "",
                              whiteSpace: this.props.checkoutMode
                                ? "unset"
                                : "normal",
                            }}
                            className={
                              this.props.checkoutMode ? "text-truncate" : ""
                            }
                          >
                            {this.props.meal.name}
                          </div>
                          {this.props.checkoutMode && (
                            <>
                              <div className="ml-1 flex items-center">
                                {this.props.meal?.limitedAvailability &&
                                !this.props.meal?.outOfStock ? (
                                  <>
                                    <div
                                      className={`inline-block font-[Karla] mr-[0.45rem] sm:mr-0 px-sm-2 bg-gray-50 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase ${
                                        !this.props.mobile && "px-1 py-[0.1rem]"
                                      }`}
                                      style={{
                                        fontSize: this.props.mobile
                                          ? 11
                                          : "12px",
                                        borderRadius: "3px",

                                        paddingLeft: this.props.mobile
                                          ? "0.2rem"
                                          : "",
                                        paddingRight: this.props.mobile
                                          ? "0.2rem"
                                          : "",
                                        paddingTop: this.props.mobile
                                          ? "0.15rem"
                                          : "",
                                        paddingBottom: this.props.mobile
                                          ? "0.15rem"
                                          : "",
                                      }}
                                    >
                                      Limited Stock
                                    </div>
                                  </>
                                ) : null}
                                {this.props.meal?.outOfStock ? (
                                  <>
                                    <div
                                      className={`inline-block font-[Karla] mr-[0.45rem] sm:mr-0 px-sm-2 bg-gray-50 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase ${
                                        !this.props.mobile && "px-1 py-[0.1rem]"
                                      }`}
                                      style={{
                                        fontSize: this.props.mobile
                                          ? 11
                                          : "12px",
                                        borderRadius: "3px",

                                        paddingLeft: this.props.mobile
                                          ? "0.2rem"
                                          : "",
                                        paddingRight: this.props.mobile
                                          ? "0.2rem"
                                          : "",
                                        paddingTop: this.props.mobile
                                          ? "0.15rem"
                                          : "",
                                        paddingBottom: this.props.mobile
                                          ? "0.15rem"
                                          : "",
                                      }}
                                    >
                                      Out Of Stock
                                    </div>
                                  </>
                                ) : null}
                                <div
                                  className="px-1 py-1 bg-gray-50 d-inline-block items-center text-gray-900 font-weight-bold border-[1px] d-inline-block border-gray-100 text-uppercase"
                                  style={{
                                    fontSize: this.props.checkoutMode ? 10 : 11,
                                    lineHeight: 1,
                                    borderRadius: 3,
                                  }}
                                >
                                  <div className="flex gap-x-1 items-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      className="h-3 w-3"
                                    >
                                      <circle cx="12" cy="12" r="10" />
                                      <path d="M12 16v-4" />
                                      <path d="M12 8h.01" />
                                    </svg>
                                    <div>Info</div>
                                  </div>
                                </div>
                                {this.props.selected > 0 ? (
                                  <div
                                    className="px-1 ml-2 py-1 bg-dark text-white font-weight-bold border d-inline-block border-dark text-uppercase"
                                    style={{
                                      fontSize: this.props.checkoutMode
                                        ? 10
                                        : 11,
                                      lineHeight: 1,
                                      borderRadius: 3,
                                    }}
                                  >
                                    {this.props.selected} In Box
                                  </div>
                                ) : null}
                              </div>
                            </>
                          )}
                        </h3>
                        <div
                          className={`meal-info-description mt-1 ${
                            this.props.checkoutMode && "compact"
                          }`}
                        >
                          {this.convertToPlain(this.props.meal.description)}
                        </div>
                        <div className={`grow`}>
                          <IonRow className="">
                            <IonCol size-xs="auto" className="pr-[0.8rem] pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.calories}
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Calories
                                </p>
                              </div>
                            </IonCol>
                            <IonCol size-xs="auto" className="pr-[0.8rem] pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.protein}g
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Protein
                                </p>
                              </div>
                            </IonCol>
                            <IonCol size-xs="auto" className="pr-[0.8rem] pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.carbs}g
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Carbs
                                </p>
                              </div>
                            </IonCol>
                            <IonCol size-xs="auto" className="pr-0 pl-0">
                              <div className="text-center">
                                <p
                                  className="text-lowercase text-dark font-weight-bold mb-0"
                                  style={{ fontSize: 16, lineHeight: 1.3 }}
                                >
                                  {this.props.meal?.nutrition?.fat}g
                                </p>
                                <p
                                  className="text-dark font-medium m-0"
                                  style={{ fontSize: "11px", lineHeight: 1 }}
                                >
                                  Fats
                                </p>
                              </div>
                            </IonCol>
                          </IonRow>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        this.props.compact && "d-none"
                      } flex items-center pt-2`}
                    >
                      {this.props.selected == 0 && this.props.showReviews ? (
                        <div className="grow">
                          {this.props.meal?.reviews &&
                          ((this.props.meal?.reviews?.count > 10 &&
                            this.props.meal?.reviews?.rating > 3.9) ||
                            this.props.meal?.reviews?.count > 25) ? (
                            <>
                              <div className="flex flex-col">
                                <div className="text-lg flex grow gap-x-0.5">
                                  {this.renderReviews(
                                    this.props.meal?.reviews?.rating * 1.1,
                                  )}
                                </div>
                                <div className="text-gray-900 pl-0.5 mt-0.5 text-xs">
                                  (
                                  {this.renderRating(
                                    this.props.meal?.reviews?.rating * 1.1,
                                  )}
                                  /5)&nbsp;
                                  {this.props.meal?.reviews.count > 1000
                                    ? "1,000+"
                                    : this.props.meal?.reviews.count}{" "}
                                  Reviews
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="flex flex-col">
                                <div className="text-lg flex grow gap-x-0.5">
                                  <IonIcon
                                    icon={star}
                                    className="text-gray-100"
                                  />
                                  <IonIcon
                                    icon={star}
                                    className="text-gray-100"
                                  />
                                  <IonIcon
                                    icon={star}
                                    className="text-gray-100"
                                  />
                                  <IonIcon
                                    icon={star}
                                    className="text-gray-100"
                                  />
                                  <IonIcon
                                    icon={star}
                                    className="text-gray-100"
                                  />
                                </div>
                                <div className="text-gray-600 pl-0.5 mt-0.5 text-xs">
                                  Collecting Reviews
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      ) : null}
                      <div
                        className={`${
                          this.props.disableAdd && !this.props.selected
                            ? "bg-[#F0F0F0] text-gray-200 border-[1px] border-[#F0F0F0]"
                            : "bg-orange-500 border-[1px] border-orange-700"
                        } ${
                          this.props.checkoutMode ? "d-none" : "d-flex"
                        } rounded-md ${
                          this.props.selected || !this.props.showReviews
                            ? "w-full"
                            : Capacitor.getPlatform() == "ios"
                            ? "w-[90px]"
                            : "w-[75px]"
                        } grid-cols-2 gap-x-4 px-2 w-[105px] h-[36px] justify-center items-center`}
                      >
                        {this.props.selected > 0 ? (
                          <>
                            <div
                              className="pr-[0.4rem]"
                              onClick={() => {
                                this.props.incrementMeal(this.props.meal, -1);

                                if (Capacitor.isNativePlatform()) {
                                  Haptics.impact({
                                    style: ImpactStyle.Light,
                                  });
                                }

                                SegmentUtils.track(
                                  "Product Removed",
                                  this.getSegmentProps(),
                                );
                              }}
                            >
                              <div className="d-flex text-center ion-align-items-center cursor-pointer">
                                <div>
                                  {this.props.selected == 1 ? (
                                    <IonIcon
                                      className="text-white text-xl relative top-[2px]"
                                      icon={trash}
                                    ></IonIcon>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="26"
                                      height="26"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      className="text-white"
                                    >
                                      <path d="M5 12h14" />
                                    </svg>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="grow">
                              <div className="text-white font-bold text-lg text-center m-0">
                                {this.props.selected} In Box
                              </div>
                            </div>
                            <div
                              className="pl-[0.4rem]"
                              onClick={() => {
                                if (this.props.disableAdd) {
                                  return;
                                }

                                if (Capacitor.isNativePlatform()) {
                                  Haptics.impact({
                                    style: ImpactStyle.Light,
                                  });
                                }

                                SegmentUtils.track(
                                  "Product Added",
                                  this.getSegmentProps(),
                                );

                                this.props.incrementMeal(this.props.meal, 1);
                              }}
                              style={{
                                cursor: this.props.disableAdd
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            >
                              <div className="d-flex text-center items-center">
                                <div
                                  style={{
                                    lineHeight: 1,
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className={`${
                                      this.props.disableAdd
                                        ? "text-orange-400"
                                        : "text-white"
                                    }`}
                                  >
                                    <path d="M5 12h14" />
                                    <path d="M12 5v14" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              onClick={() => {
                                if (this.props.disableAdd) {
                                  return;
                                }

                                this.props.incrementMeal(this.props.meal, 1);

                                if (Capacitor.isNativePlatform()) {
                                  Haptics.impact({
                                    style: ImpactStyle.Light,
                                  });
                                }

                                SegmentUtils.track(
                                  "Product Added",
                                  this.getSegmentProps(),
                                );
                              }}
                              className={``}
                            >
                              <div
                                className="d-flex grid-cols-2 gap-x-1 text-center ion-align-items-center"
                                style={{
                                  cursor: this.props.disableAdd
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className={`${
                                    this.props.disableAdd
                                      ? "text-gray-300"
                                      : "text-white"
                                  } ${this.props.meal?.outOfStock && "hidden"}`}
                                >
                                  <path d="M5 12h14" />
                                  <path d="M12 5v14" />
                                </svg>
                                <div
                                  className={`${
                                    this.props.meal?.outOfStock
                                      ? "text-sm tracking-tight leading-4"
                                      : "text-base"
                                  } ${
                                    this.props.disableAdd
                                      ? "text-gray-300"
                                      : "text-white"
                                  } font-bold`}
                                >
                                  {this.props.meal?.outOfStock
                                    ? "Out Of Stock"
                                    : this.props.disableAdd
                                    ? "Full"
                                    : "Add"}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>

                      <div
                        className={`${
                          this.props.compact && !this.props.checkoutMode
                            ? "d-block mt-1"
                            : "d-none"
                        }`}
                      >
                        <IonGrid className="p-0">
                          <IonRow className="ion-ion-align-items-center">
                            <IonCol
                              className="pr-0 py-0 text-right flex items-center justify-end"
                              size-xs="12"
                            >
                              <div
                                className="px-1 py-1 bg-gray-50 d-inline-block items-center text-gray-900 font-weight-bold border-[1px] d-inline-block border-gray-100 text-uppercase"
                                style={{
                                  fontSize: this.props.checkoutMode ? 10 : 11,
                                  lineHeight: 1,
                                  borderRadius: 3,
                                }}
                              >
                                <div className="flex gap-x-1 items-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="h-3 w-3"
                                  >
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 16v-4" />
                                    <path d="M12 8h.01" />
                                  </svg>
                                  <div>Info</div>
                                </div>
                              </div>
                              {this.props.selected > 0 ? (
                                <div
                                  className="px-1 ml-2 py-1 bg-dark text-white font-weight-bold border d-inline-block border-dark text-uppercase"
                                  style={{
                                    fontSize: this.props.checkoutMode ? 10 : 11,
                                    lineHeight: 1,
                                    borderRadius: 3,
                                  }}
                                >
                                  {this.props.selected} In Box
                                </div>
                              ) : null}
                            </IonCol>
                          </IonRow>
                        </IonGrid>
                      </div>
                    </div>
                  </div>
                  <div
                    onClick={() => this.openMealInfo(this.props.meal)}
                    className={`mt-0 mb-0 mr-0 mr-0 rounded-md border-l border-gray-100 ${
                      !this.props.checkoutMode && "cursor-pointer"
                    }`}
                    style={{
                      overflow: " hidden",
                      height: "auto",
                      width: this.props.checkoutMode
                        ? "80px"
                        : Capacitor.getPlatform() == "ios"
                        ? "130px"
                        : "115px",
                      minWidth: this.props.checkoutMode
                        ? "80px"
                        : Capacitor.getPlatform() == "ios"
                        ? "130px"
                        : "115px",

                      position: "relative",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      minHeight: this.props.compact ? "80px" : "115px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${
                          this.props.meal.platedImageURL
                            ? this.props.meal.platedImageURL
                            : this.props.meal.imageURL
                        })`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: this.props.meal?.platedImageURL
                          ? "150%"
                          : "240%",
                        position: "absolute",
                        left: 0,
                        top: 0,
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",

                        width: 24,
                        height: 24,
                      }}
                      className="text-right bg-white border-[1px] border-gray-800 rounded-md right-1 bottom-1"
                    >
                      <img
                        src={this.getProteinIcon(this.props.meal)}
                        style={{ width: "24px", position: "relative", top: -1 }}
                      ></img>
                    </div>
                    {this.props.allowFavorite && this.props.favorite ? (
                      <div
                        className="absolute top-1 left-1 h-[24px] border-red-500 border-[1px] w-[24px] flex justify-center items-center bg-white rounded-md"
                        style={{ lineHeight: 1 }}
                      >
                        <IonIcon
                          icon={heart}
                          style={{ position: "relative", top: 1 }}
                          className="text-red-500"
                        ></IonIcon>
                      </div>
                    ) : null}
                    <div
                      className="absolute top-1 border-[1px] border-gray-800 text-gray-400 font-[19px] right-1 h-[24px] w-[24px] flex justify-center items-center text-gray-800 bg-white rounded-md font-weight-bold text-uppercase"
                      style={{
                        lineHeight: 1,
                      }}
                    >
                      <IonIcon
                        className="text-gray-800"
                        icon={information}
                      ></IonIcon>
                    </div>

                    {this.props.meal?.spicy ? (
                      <div className="absolute border-[1px] border-red-500 left-1 bottom-1 h-[24px] w-[24px] flex justify-center items-center bg-white rounded-md">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="140px"
                          height="185px"
                          viewBox="0 0 140 185"
                          version="1.1"
                          className="h-[15px]"
                        >
                          <title>Meal Heat Flame</title>
                          <g
                            id="Meal-Heat-Flame"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path
                              d="M107.681558,0.0427138334 C107.659186,0.0643153614 107.637728,0.0869484654 107.617246,0.110547115 C90.7193105,5.68520951 77.1764537,22.2532462 69.8716471,40.7059469 C62.8424875,58.4622994 61.7742218,77.9317946 69.2919377,91.4332384 C58.843956,92.1203807 50.0433588,89.4909601 45.1373211,81.8453565 C39.9927803,73.8280793 38.8693021,60.0655214 45.0084773,38.4619868 C45.11997,38.0538801 44.9963276,37.6145904 44.6918305,37.3369706 C44.3873335,37.0593508 43.9576496,36.994155 43.5914148,37.170005 C9.18969463,55.8789305 -4.47664656,92.8150112 1.27256306,125.092861 C7.02172892,157.370712 32.2868081,185 74.9602098,185 C94.77662,185 111.592939,177.831255 123.140599,164.532188 C134.688259,151.233341 140.928016,131.844035 139.887794,107.685035 C138.843459,80.1224131 125.131181,67.2739748 114.895824,54.5777429 C109.778168,48.2296489 105.567777,41.903777 103.945745,33.770038 C102.323714,25.636321 103.289933,15.5507234 108.905486,1.53852578 C109.072021,1.15188858 109.010228,0.698295065 108.747234,0.376870473 C108.48424,0.0554458807 108.068124,-0.0750500267 107.681558,0.0426697859 L107.681558,0.0427138334 Z"
                              id="Path"
                              fill="#F5365C"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    ) : null}
                  </div>
                </div>
              </IonCardContent>
            </IonCard>
          </>
        ) : (
          <>
            <IonCard
              mode="ios"
              className="shadow-sm m-0 border border-gray-100 rounded-lg overflow-hidden"
            >
              <IonCardContent
                className={`p-0 ${
                  !this.props.checkoutMode && "cursor-pointer"
                }`}
              >
                <div
                  style={{
                    position: "relative",
                    background: "var(--superlight)",
                  }}
                  className="p-0 border-b-[1px] border-gray-100"
                  onClick={() => this.openMealInfo(this.props.meal)}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "0.5rem",
                      left: "0.5rem",
                      lineHeight: 1,
                      fontSize: "12px",
                      zIndex: 2,
                    }}
                    className="flex items-center"
                  >
                    {this.props.allowFavorite && this.props.favorite ? (
                      <div className="h-[24px] w-[24px] flex justify-center items-center bg-white border-[1px] border-red-500 rounded-md mr-2">
                        <IonIcon
                          icon={heart}
                          style={{ position: "relative", top: 1 }}
                          className="text-red-500"
                        ></IonIcon>
                      </div>
                    ) : null}

                    <div className="h-[24px] px-1 rounded-md bg-white d-inline-flex items-center text-gray-900 font-weight-bold border-[1px] border-gray-800 text-uppercase">
                      <div className="flex gap-x-1 items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="h-[13px] w-[13px]"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 16v-4" />
                          <path d="M12 8h.01" />
                        </svg>
                        <div style={{ fontSize: 11 }}>Info</div>
                      </div>
                    </div>
                  </div>
                  {this.props.selected > 0 ? (
                    <div
                      className="cursor-pointer bg-primary text-white px-2 py-1 text-uppercase font-weight-bold rounded-md"
                      style={{
                        position: "absolute",
                        top: "0.5rem",
                        right: "0.5rem",
                        lineHeight: 1,
                        fontSize: "12px",
                        zIndex: 2,
                      }}
                    >
                      {this.props.selected} In Box
                    </div>
                  ) : null}
                  <div
                    style={{
                      position: "absolute",
                      right: "0.5rem",
                      bottom: "0.5rem",
                      width: 24,
                      height: 24,
                      zIndex: 2,
                    }}
                    className="bg-white border-[1px] border-gray-800 rounded-md"
                  >
                    <img
                      src={this.getProteinIcon(this.props.meal)}
                      style={{ width: "24px", position: "relative", top: -1 }}
                    ></img>
                  </div>
                  <div
                    className="meal-info-image"
                    style={{
                      width: "100%",
                      backgroundImage: `url(${
                        this.props.meal.platedImageURL
                          ? this.props.meal.platedImageURL
                          : this.props.meal.imageURL
                      })`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: this.props.meal?.platedImageURL
                        ? "90%"
                        : "120%",
                    }}
                  ></div>
                  <div
                    className="flex items-center gap-x-1 flex-wrap"
                    style={{
                      position: "absolute",
                      left: "0.5rem",
                      bottom: "0.5rem",
                      zIndex: 2,
                    }}
                  >
                    {this.props.meal?.limitedAvailability &&
                    !this.props.meal?.outOfStock ? (
                      <div
                        className="inline-block px-1 py-[0.1rem] bg-gray-50 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase"
                        style={{
                          fontSize: "12px",
                          borderRadius: "3px",
                        }}
                      >
                        Limited Stock
                      </div>
                    ) : null}
                    {this.props.meal?.outOfStock ? (
                      <div
                        className="inline-block px-1 py-[0.1rem] bg-gray-50 border-[1px] border-yellow-900 text-gray-900 font-weight-700 text-uppercase"
                        style={{
                          fontSize: "12px",
                          borderRadius: "3px",
                        }}
                      >
                        Out Of Stock
                      </div>
                    ) : null}
                    {this.renderTopCategory(this.props.meal)}
                    {this.props.meal?.spicy ? (
                      <div className="inline-block h-[22px] px-1 border-[1px] border-red-500 bg-white rounded-md flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="140px"
                          height="185px"
                          viewBox="0 0 140 185"
                          version="1.1"
                          style={{
                            height: 13,
                            width: "auto",
                            position: "relative",
                            top: 1,
                          }}
                        >
                          <title>Meal Heat Flame</title>
                          <g
                            id="Meal-Heat-Flame"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path
                              d="M107.681558,0.0427138334 C107.659186,0.0643153614 107.637728,0.0869484654 107.617246,0.110547115 C90.7193105,5.68520951 77.1764537,22.2532462 69.8716471,40.7059469 C62.8424875,58.4622994 61.7742218,77.9317946 69.2919377,91.4332384 C58.843956,92.1203807 50.0433588,89.4909601 45.1373211,81.8453565 C39.9927803,73.8280793 38.8693021,60.0655214 45.0084773,38.4619868 C45.11997,38.0538801 44.9963276,37.6145904 44.6918305,37.3369706 C44.3873335,37.0593508 43.9576496,36.994155 43.5914148,37.170005 C9.18969463,55.8789305 -4.47664656,92.8150112 1.27256306,125.092861 C7.02172892,157.370712 32.2868081,185 74.9602098,185 C94.77662,185 111.592939,177.831255 123.140599,164.532188 C134.688259,151.233341 140.928016,131.844035 139.887794,107.685035 C138.843459,80.1224131 125.131181,67.2739748 114.895824,54.5777429 C109.778168,48.2296489 105.567777,41.903777 103.945745,33.770038 C102.323714,25.636321 103.289933,15.5507234 108.905486,1.53852578 C109.072021,1.15188858 109.010228,0.698295065 108.747234,0.376870473 C108.48424,0.0554458807 108.068124,-0.0750500267 107.681558,0.0426697859 L107.681558,0.0427138334 Z"
                              id="Path"
                              fill="#F5365C"
                            />
                          </g>
                        </svg>
                      </div>
                    ) : null}
                  </div>
                </div>
              </IonCardContent>
              <IonCardContent
                className={`px-3 pb-0 pt-2 ${
                  !this.props.checkoutMode && "cursor-pointer"
                }`}
                onClick={() => this.openMealInfo(this.props.meal)}
              >
                <h2
                  className="mb-1 text-dark font-weight-500 text-center font-[SourceSerif]"
                  style={{ fontSize: 18 }}
                >
                  {this.props.meal.name}
                </h2>
                <div className="meal-info-description text-center">
                  {this.convertToPlain(this.props.meal.description)}
                </div>
              </IonCardContent>
              <IonCardContent
                className={`px-3 pt-2 pb-2 ${
                  !this.props.checkoutMode && "cursor-pointer"
                }`}
                onClick={() => this.openMealInfo(this.props.meal)}
              >
                <IonRow className="ion-justify-content-center">
                  <IonCol size-xs="auto" className="py-0 pl-0 pr-3 text-center">
                    <p
                      style={{ fontSize: 16, lineHeight: 1.3 }}
                      className="text-lowercase text-dark font-weight-bold mb-0"
                    >
                      {this.props.meal.nutrition.calories}
                    </p>
                    <p
                      className="text-uppercase text-dark font-medium m-0"
                      style={{ fontSize: "11px", lineHeight: 1 }}
                    >
                      Cal
                    </p>
                  </IonCol>
                  <IonCol size-xs="auto" className="py-0 pl-0 pr-3 text-center">
                    <p
                      style={{ fontSize: 16, lineHeight: 1.3 }}
                      className="text-lowercase text-dark font-weight-bold mb-0"
                    >
                      {this.props.meal.nutrition.protein}g
                    </p>
                    <p
                      className="text-uppercase text-dark font-medium m-0"
                      style={{ fontSize: "11px", lineHeight: 1 }}
                    >
                      Protein
                    </p>
                  </IonCol>
                  <IonCol size-xs="auto" className="py-0 pl-0 pr-3 text-center">
                    <p
                      style={{ fontSize: 16, lineHeight: 1.3 }}
                      className="text-lowercase text-dark font-weight-bold mb-0"
                    >
                      {this.props.meal.nutrition.carbs}g
                    </p>
                    <p
                      className="text-uppercase text-dark font-medium m-0"
                      style={{ fontSize: "11px", lineHeight: 1 }}
                    >
                      Carbs
                    </p>
                  </IonCol>
                  <IonCol size-xs="auto" className="py-0 pl-0 pr-0 text-center">
                    <p
                      style={{ fontSize: 16, lineHeight: 1.3 }}
                      className="text-lowercase text-dark font-weight-bold mb-0"
                    >
                      {this.props.meal.nutrition.fat}g
                    </p>
                    <p
                      className="text-uppercase text-dark font-medium m-0"
                      style={{ fontSize: "11px", lineHeight: 1 }}
                    >
                      Fats
                    </p>
                  </IonCol>
                </IonRow>
              </IonCardContent>
              <IonCardContent className="px-3 pt-0 pb-3">
                <div
                  className={`${
                    this.props.disableAdd && !this.props.selected
                      ? "bg-[#F0F0F0] text-gray-200 border-[1px] border-[#F0F0F0]"
                      : "bg-orange-500 border-[1px] border-orange-700"
                  } d-flex rounded-md w-full h-[36px] justify-center items-center`}
                >
                  {this.props.selected > 0 ? (
                    <>
                      <div
                        className="pl-[0.4rem]"
                        onClick={() => {
                          this.props.incrementMeal(this.props.meal, -1);

                          SegmentUtils.track(
                            "Product Removed",
                            this.getSegmentProps(),
                          );
                        }}
                      >
                        <div className="d-flex text-center ion-align-items-center cursor-pointer">
                          <div>
                            {this.props.selected == 1 ? (
                              <IonIcon
                                className="text-white text-xl relative top-[4px]"
                                icon={trash}
                              ></IonIcon>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="text-white"
                              >
                                <path d="M5 12h14" />
                              </svg>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="grow">
                        <div className="text-white font-bold text-lg text-center m-0">
                          {this.props.selected} In Box
                        </div>
                      </div>
                      <div
                        className="pr-[0.4rem]"
                        onClick={() => {
                          if (this.props.disableAdd) {
                            return;
                          }

                          SegmentUtils.track(
                            "Product Added",
                            this.getSegmentProps(),
                          );

                          this.props.incrementMeal(this.props.meal, 1);
                        }}
                        style={{
                          cursor: this.props.disableAdd
                            ? "not-allowed"
                            : "pointer",
                        }}
                      >
                        <div className="d-flex text-center items-center">
                          <div style={{ lineHeight: 1 }}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className={`${
                                this.props.disableAdd
                                  ? "text-orange-400"
                                  : "text-white"
                              }`}
                            >
                              <path d="M5 12h14" />
                              <path d="M12 5v14" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div
                      onClick={() => {
                        if (this.props.disableAdd) {
                          return;
                        }

                        this.props.incrementMeal(this.props.meal, 1);

                        SegmentUtils.track(
                          "Product Added",
                          this.getSegmentProps(),
                        );
                      }}
                    >
                      <div
                        className="d-flex grid-cols-2 gap-x-1 text-center ion-align-items-center"
                        style={{
                          cursor: this.props.disableAdd
                            ? "not-allowed"
                            : "pointer",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className={`${
                            this.props.disableAdd
                              ? "text-gray-300"
                              : "text-white"
                          } ${this.props.meal?.outOfStock && "hidden"}`}
                        >
                          <path d="M5 12h14" />
                          <path d="M12 5v14" />
                        </svg>
                        <div
                          className={`${
                            this.props.meal?.outOfStock
                              ? "text-sm tracking-tight leading-4"
                              : "text-base"
                          } ${
                            this.props.disableAdd
                              ? "text-gray-300"
                              : "text-white"
                          } font-bold`}
                        >
                          {this.props.meal?.outOfStock
                            ? "Out Of Stock"
                            : this.props.disableAdd
                            ? "Full"
                            : "Add To Box"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </IonCardContent>
            </IonCard>
          </>
        )}
      </>
    );
  }
}

export default MealOptionCard;
